// @ts-check
import { getAll } from "../utilities/querySelector";

const questions = getAll( '.questions' );

questions.forEach( question => {
    const links = getAll( '[data-step-change]', question );
    const steps = getAll( '[data-step-name]', question );

    links.forEach( link => {
        link.addEventListener( 'click', e => {
            const stepName = link.dataset.stepChange;

            steps.forEach( step => {
                if ( step.dataset.stepName !== stepName ) {
                    step.removeAttribute( 'data-step-active' );
                    step.setAttribute( 'aria-hidden', 'true' );
                } else {
                    step.setAttribute( 'data-step-active', '' );
                    step.setAttribute( 'aria-hidden', 'false' );
                }
            } );
        } );
    } );
} );